export default function App() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-1 w-full">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">移动追剧</h2>
            <p className="text-foreground-500 text-sm mb-6 leading-relaxed max-w-md">
              香蕉影视移动端专为手机追剧场景深度优化，轻量流畅不占内存。
              无论通勤路上还是睡前时光，打开即看，随时随地畅享高清追剧体验。
              支持iOS和Android双平台。
            </p>

            <div className="space-y-3 mb-6">
              <div className="flex items-center gap-3 text-sm text-foreground-600">
                <span className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 text-xs flex-shrink-0">
                  <i className="ri-check-line"></i>
                </span>
                极速启动，3秒进入播放界面
              </div>
              <div className="flex items-center gap-3 text-sm text-foreground-600">
                <span className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 text-xs flex-shrink-0">
                  <i className="ri-check-line"></i>
                </span>
                智能续播，自动记忆上次观看位置
              </div>
              <div className="flex items-center gap-3 text-sm text-foreground-600">
                <span className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 text-xs flex-shrink-0">
                  <i className="ri-check-line"></i>
                </span>
                流量优化，标清模式节省70%流量
              </div>
              <div className="flex items-center gap-3 text-sm text-foreground-600">
                <span className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 text-xs flex-shrink-0">
                  <i className="ri-check-line"></i>
                </span>
                夜间模式，暗光环境护眼追剧
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <a href="#hero" className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 rounded-lg text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-apple-line text-lg"></i>
                App Store 下载
              </a>
              <a href="#hero" className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-android-line text-lg"></i>
                Android 下载
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center">
            <div className="relative w-56 h-[28rem] rounded-2xl overflow-hidden bg-background-200 border-4 border-foreground-900">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20a%20video%20streaming%20app%20interface%20with%20Chinese%20drama%20thumbnails%20in%20a%20warm%20coral%20and%20cream%20color%20scheme%2C%20clean%20minimalist%20UI%20design%20with%20rounded%20cards%20and%20play%20buttons%2C%20phone%20held%20in%20hand%20against%20soft%20neutral%20background%2C%20modern%20lifestyle%20photography%2C%20warm%20ambient%20lighting%2C%20high%20quality%20product%20shot&width=400&height=800&seq=app-mockup-2026&orientation=portrait"
                alt="香蕉影视移动端应用界面展示"
                className="w-full h-full object-cover object-top"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  if (target.parentElement) target.parentElement.style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}